import type { Core } from 'chessboard/core/config/types';
import { createGetSet } from 'src/utils/create-get-set';
import { createQueue } from 'utils/queue';
import type { Modes } from 'chessboard/modes/config/types';
import type { Renderer } from 'chessboard/renderers/config/types';

/**
 * Create a context that will be passed to each of the plugins during the
 * run cycle.
 */
export function createContext({
  params,
  run,
}: {
  params: Core.ContextParams;
  run: Core.Run;
}): Core.Context {
  const queue = createQueue(false);

  const context: Core.Context = {
    queue,
    reset,
    run,
    setMode,
    setRenderer,
    state: createGetSet(),
    ...params,
  };

  context.reset();

  return <Core.Context>context;

  /**
   * Reset the current context.
   */
  function reset() {
    /**
     * The queue and the state are temporary - i.e. set per run - but all other parameters
     * are permanent, so are not cleared in this reset function.
     */
    context.queue = createQueue(false);
    context.state = createGetSet();
  }

  /**
   * Set the mode property.
   */
  function setMode(mode: Modes.API.Extended) {
    context.mode = mode;
  }

  /**
   * Set the renderer property.
   */
  function setRenderer(newRenderer?: Renderer.Model) {
    context.renderer = newRenderer;
  }
}
